import { FC } from "react";
import { connectRefinementList } from "react-instantsearch-dom";
import { RefinementListProvided, SearchState } from "react-instantsearch-core";
import { useRouter } from "next/router";
import { isArray } from "lodash-es";
import { StyledFilters } from "src/organisms/AlgoliaProductList/DesktopFilterVeiw/CategoriesTree/CategoriesTree.styled";
import { MultiselectHitType } from "src/types/Algolia";
import { useMultiselect } from "./useMultiselect";
import MultiselectCategories from "./MultiselectCategories";

interface Props extends RefinementListProvided {
  genderId: string;
  selectedCatSlug: string[];
  setStatePayload?: (
    payload: SearchState & { selectedCatSlug: string[] }
  ) => void;
  departmentSlug?: string;
  isNewPlp: boolean;
  categoriesTree?: MultiselectHitType[];
  isMultiselectCategories: boolean;
}

const MultiselectCategoryWrapper: FC<Props> = ({
  items,
  selectedCatSlug,
  genderId,
  setStatePayload,
  departmentSlug,
  isNewPlp,
  categoriesTree,
  isMultiselectCategories,
}) => {
  const router = useRouter();
  const { brandOrCategoriesSlug: slug } = router.query;
  const currentSlug = slug && isArray(slug) ? slug[slug.length - 1] : slug;

  const { tree, handleRefine, isSelected } = useMultiselect({
    items,
    genderId,
    currentRefinement: selectedCatSlug,
    setStatePayload,
    departmentSlug,
    isNewPlp,
    categoriesTree: categoriesTree?.[0].items,
    isMultiselectCategories,
    slug,
    currentSlug,
  });

  return (
    <StyledFilters>
      <MultiselectCategories
        items={tree}
        refine={handleRefine}
        isSelected={isSelected}
        currentSlug={currentSlug}
        shouldShowChildren={isMultiselectCategories || currentSlug === genderId}
      />
    </StyledFilters>
  );
};

export default connectRefinementList(MultiselectCategoryWrapper);
